var React = require('react');

function UserPortal (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.61 17.04h-1.17V18h1.17v-.97zm2.35 0h-1.17V18h1.17v-.97zm2.34 0h-1.17V18h1.17v-.97zm1.17-3.4h-.58v-.98H19.7v.97h-4.68v-.97h-1.17v.97h-.59c-.65 0-1.16.44-1.16.98l-.01 6.81c0 .53.52.98 1.17.98h8.2c.65 0 1.17-.44 1.17-.98V14.6c0-.53-.52-.97-1.17-.97zm0 7.78h-8.2v-5.35h8.2v5.35z","key":0}),React.createElement("path",{"d":"M10.83 15.1h-6.5v-.87c0-1.74 3.48-2.7 5.22-2.7.74 0 1.78.18 2.74.5.26-.1.54-.16.83-.16h4.28v-8.1c0-.95-.79-1.73-1.75-1.73H3.45c-.97 0-1.74.78-1.74 1.74v12.2c0 .96.77 1.74 1.74 1.74h7.38v-2.61zM9.55 4.66a2.61 2.61 0 1 1 0 5.22 2.61 2.61 0 0 1 0-5.22z","key":1})]);
}

UserPortal.displayName = "UserPortal";

UserPortal.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = UserPortal;

UserPortal.default = UserPortal;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/UserPortal.svg
// module id = 655
// module chunks = 168707334958949